/**
 * Translation-key pair for a single prompt context (title + body).
 */
export type PromptCopy = {
  titleId: string;
  bodyId: string;
};

/**
 * Map of Redux action types whose `/fulfilled` dispatch should pop the
 * `<EnableNotificationsFlow />` modal, with the per-trigger copy used when
 * the modal renders. Add a new entry to enable a new trigger; the middleware
 * picks it up automatically.
 */
export const NOTIFICATION_PROMPT_TRIGGERS = {
  'EditListingPage/publishListing/fulfilled': {
    titleId: 'EnableNotificationsFlow.publishListing.title',
    bodyId: 'EnableNotificationsFlow.publishListing.body',
  },
  'CheckoutPage/initiateInquiry/fulfilled': {
    titleId: 'EnableNotificationsFlow.initiateInquiry.title',
    bodyId: 'EnableNotificationsFlow.initiateInquiry.body',
  },
} as const satisfies Record<string, PromptCopy>;

export type NotificationPromptTriggerType = keyof typeof NOTIFICATION_PROMPT_TRIGGERS;

/**
 * Copy for the push opt-in shown on the order-confirmed page. Fired on that
 * page's mount rather than at checkout so the native permission prompt is not
 * dismissed by the redirect to `/order-confirmed/:txId`.
 */
export const ORDER_CONFIRMED_PROMPT_COPY: PromptCopy = {
  titleId: 'EnableNotificationsFlow.initiateOrder.title',
  bodyId: 'EnableNotificationsFlow.initiateOrder.body',
};

/**
 * Fallback copy used when the flow is opened without a specific trigger
 * (e.g. via the dev FAB).
 */
export const DEFAULT_PROMPT_COPY: PromptCopy = {
  titleId: 'EnableNotificationsFlow.default.title',
  bodyId: 'EnableNotificationsFlow.default.body',
};
